<template>
  <section class="alert alert-info">
    <a href="https://mailchi.mp/1e660cfec101/premium-poker-tools">Subscribe</a> to be emailed new posts.</p>
  </section>
</template>

<script>
export default {
  name: 'subscribe-to-blog',
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blog/subscribe-to-blog.vue